import LendingWorkQueuePage from "../lending-queue/LendingWorkQueuePage";

const IriaPayWorkQueuePage = () => (
  <LendingWorkQueuePage
    partnerCode="IRIA_PAY"
    partnerTitle="ایریاپی"
    subtitle="پیگیری متمرکز فرآیند وام ایریاپی — شامل تب‌های در انتظار چک، رد شده و پرداخت شده"
  />
);

export default IriaPayWorkQueuePage;
